'use client';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './footer-mobile.scss';

interface Props {
  onPrev: () => void;
  onNext: () => void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
}

export default function MobileFooterButtons({
  onPrev,
  onNext,
  prevDisabled = false,
  nextDisabled = false,
}: Props) {
  return (
    <div className='footer-mobile'>
      <div className='footer-mobile-border' style={{ borderColor: 'transparent' }} />
      <div className='footer-mobile-container'>
        <div className='footer-intro-mobile'>
          <div className='text-footer-mobile'>
            <div
              className='footer-button'
              onClick={onPrev}
              style={{
                opacity: prevDisabled ? 0.3 : 1,
                pointerEvents: prevDisabled ? 'none' : 'auto',
              }}
            >
              <LeftOutlined className='icon-transfer' />
            </div>
            <div className='footer-mid' />
            <div
              className='footer-button'
              onClick={onNext}
              style={{
                opacity: nextDisabled ? 0.3 : 1,
                pointerEvents: nextDisabled ? 'none' : 'auto',
              }}
            >
              <RightOutlined className='icon-transfer' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
